export default class PasswordReveal {
    constructor(elm, args) {
        var password = elm.querySelector('#password-input');
        var toggler = elm.querySelector('#toggler');

        function showHidePassword() {
            if (password.type == 'password') {
                password.setAttribute('type', 'text');
                toggler.classList.add('eye-visible');
            } else {
                toggler.classList.remove('eye-visible');
                password.setAttribute('type', 'password');
            }
        }

        toggler.addEventListener('click', showHidePassword);
    }
}
